import { call, put, takeLatest } from 'redux-saga/effects';

import * as subscribeActions from './subscribeActions.js';
import { updateSubscribeApiCall } from './subscribeAPI.js';

function* updateSubscribeSaga({ payload }) {
  try {
    const { data } = yield call(updateSubscribeApiCall, payload);
    yield put(subscribeActions.subscribeUpdateStore(data));
  } catch (error) {
    yield put(subscribeActions.subscribeUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* subscribeWatcher() {
  yield takeLatest(subscribeActions.subscribeUpdateRequest.type, updateSubscribeSaga);
}
